"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Benefit = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _utils = require("../../utils");
var _BenefitsLayoutClasses = require("./BenefitsLayoutClasses");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Benefit = ({
  benefit
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.BenefitBox, {
    className: _BenefitsLayoutClasses.benefitsLayoutClasses.benefitBox,
    "data-testid": getTestId(_constants.BENEFITS_BOX),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BoxIcon, {
      "data-testid": getTestId(_constants.BENEFITS_BOX_ICON),
      children: benefit?.icon != null ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.Icon, {
        iconName: benefit.icon
      }) : null
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.BoxContent, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BoxTitle, {
        "data-testid": getTestId(_constants.BENEFITS_BOX_TITLE),
        children: benefit?.caption
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.InnerTextWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledTextWithHtml, {
          isOverflowVisible: false,
          "data-testid": getTestId(_constants.BENEFITS_BOX_TEXT),
          html: (0, _utils.transformHtmlContent)(benefit?.content?.[0]),
          maxLines: 3
        })
      })]
    })]
  });
};
exports.Benefit = Benefit;
